export default __webpack_public_path__ + "static/media/img-0293-zambia-half-face.eeaee499.png";